module.exports = __webpack_public_path__ + "static/media/profile_img_eliecer.140facd1.png";